import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Spinner, Alert } from 'react-bootstrap';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';

const StyledContainer = styled(Container)`
    font-family: Montserrat, sans-serif;
    color: rgba(41, 37, 97, 1);
    color: rgba(41, 37, 97, 1);
    background: rgb(234, 222, 208);
    padding: 40px 12%;
    text-align: left;
    border-radius: 2px;

    margin: 0 auto;
`;

const Title = styled.h1`
    font-size: 34px;
    font-weight: 700;
    font-family: Montserrat, sans-serif;
    padding: 30px 0px;
    color: #292561;
`;

const DescriptionText = styled.p`
    font-size: 20px;
    font-weight: 500;
    color: #292561;
    font-family: Montserrat, sans-serif;
    margin-top: 10px;
    margin-bottom: 0;
`;

const NextSteps = styled.h3`
    font-size: 22px;
    font-weight: 700;
    color: #292561;
    font-family: Montserrat, sans-serif;
    margin-top: 20px;
    margin-bottom: 10px;
`;

const FooterText = styled.p`
    font-size: 20px;
    font-weight: 500;
    color: #292561;
    font-family: Montserrat, sans-serif;
    margin-bottom: 10px;
    width: 80%;

    @media (min-width: 300px) and (max-width: 500px) {
        width: 100%;
    }
`;

export default function PaymentSuccess() {
    const location = useLocation();

    const scrollToElement = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    useEffect(() => {
        if (location.pathname === '/success') {
            scrollToElement('success');
        }
    }, [location.pathname]);

    return (
        <>
            <StyledContainer fluid id="success">
                <Row>
                    <Col>
                        <Title>Success!</Title>
                        <DescriptionText>Thank you for your payment.</DescriptionText>
                    </Col>
                </Row>
                <Row className="mt-4">
                    <Col>
                        <FooterText>
                            Renewed na ang iyong Home Protection Insurance! Matatanggap ang iyong Confirmation of
                            Insurance Coverage (COIC) sa email address mo. Huwag kalimutang i-save ang iyong COIC for
                            future reference.
                        </FooterText>
                    </Col>
                </Row>
            </StyledContainer>
        </>
    );
}
